import { useContext, useEffect } from 'react';

import { PartnerIntakeContext } from '@/Contexts/PartnerIntakeContext';
import { ProgramNames } from '@/models/Program';
import FuzzyMatchModal from './common/FuzzyMatchModal';
import TreeCampusHealthcareSignUp from './TreeCampusHealthcare/TreeCampusHealthcareSignUp';
import TreeCampusHigherEdSignUp from './TreeCampusHigherEd/TreeCampusHigherEdSignUp';
import TreeCampusK12SignUp from './TreeCampusK12/TreeCampusK12SignUp';
import TreeCityUsaSignUp from './TreeCityUsa/TreeCityUsaSignUp';
import TreeCityWorldSignUp from './TreeCityWorld/TreeCityWorldSignUp';
import TreeLineSignUp from './TreeLine/TreeLineSignUp';
import { IntakeResponse } from '@/models/IntakeResponse';

interface PartnerSignUpFormProps {
  onSubmit: (intakeResponse: IntakeResponse) => void;
}

function PartnerSignUpForm({ onSubmit }: PartnerSignUpFormProps) {
  const { isNewPartner, selectedProgramInfo, partnerInfo } = useContext(PartnerIntakeContext);

  const renderSignUpForm = () => {
    if (selectedProgramInfo == null || partnerInfo == null) return null;

    switch (selectedProgramInfo.id) {
      case ProgramNames.TreeCityUSA:
        return <TreeCityUsaSignUp onSubmit={onSubmit} selectedProgramInfo={selectedProgramInfo} />;
      case ProgramNames.TreeCitiesWorld:
        return (
          <TreeCityWorldSignUp onSubmit={onSubmit} selectedProgramInfo={selectedProgramInfo} />
        );
      case ProgramNames.TreeCampusHealthcare:
        return (
          <TreeCampusHealthcareSignUp
            onSubmit={onSubmit}
            selectedProgramInfo={selectedProgramInfo}
          />
        );
      case ProgramNames.TreeCampusHigherEducation:
        return (
          <TreeCampusHigherEdSignUp onSubmit={onSubmit} selectedProgramInfo={selectedProgramInfo} />
        );
      case ProgramNames.TreeLineUSA:
        return <TreeLineSignUp onSubmit={onSubmit} />;
      case ProgramNames.TreeCampusK12:
        return (
          <TreeCampusK12SignUp
            onSubmit={onSubmit}
            selectedProgramInfo={selectedProgramInfo}
            partnerInfo={partnerInfo}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      {renderSignUpForm()}

      {isNewPartner && <FuzzyMatchModal />}
    </>
  );
}

export default PartnerSignUpForm;
